export default "__VITE_ASSET__lnJmeuVY__"